import React from 'react';
import './styles.scss';
import { Box, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export interface IModalPaymentCompletedProps {
  copayValue: number;
  creditCardValue: string;
  receiptUrl: string;
  onClose: () => void;
}

export const ModalPaymentCompleted: React.FunctionComponent<
  IModalPaymentCompletedProps
> = (props) => {
  const { copayValue, creditCardValue, onClose } = props;
  const displayCopay =
    typeof copayValue === 'string' ? copayValue : (copayValue || 0).toFixed(2);

  return (
    <div className="modal-default modal-payment-completed">
      <div className="modal-mains" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <Typography variant="h4" fontWeight="bold">
          Thank you!
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <CheckCircleIcon sx={{ color: '#20c997' }} />
          <Typography variant="h6">
            Payment Completed
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="h5">Your copay is</Typography>
          <Typography variant="h5" fontWeight="bold">${displayCopay}</Typography>
        </Box>
        <Typography variant="body1">Billed to {creditCardValue}</Typography>
        <Box sx={{ display: 'flex', gap: 1, borderTop: '1px solid #E3E3E3', paddingTop: 1 }}>
          <Button
            variant="outlined"
            size="large"
            onClick={() => window.open(props.receiptUrl, '_blank')}
          >
            Request a receipt
          </Button>
          <Button
            variant="contained"
            size="large"
            onClick={onClose}>
            Close
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default ModalPaymentCompleted;
